import { render, staticRenderFns } from "./ModalEditDocument.vue?vue&type=template&id=7abed652&scoped=true&"
import script from "./ModalEditDocument.vue?vue&type=script&lang=js&"
export * from "./ModalEditDocument.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditDocument.vue?vue&type=style&index=0&id=7abed652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abed652",
  null
  
)

export default component.exports